import type {ReactElement} from 'react';
import React, {useCallback, useEffect, useRef} from 'react';
import ReactCanvasConfetti from 'react-canvas-confetti';
import type {CreateTypes, Options} from 'canvas-confetti';

interface OnboardingConfettiExplosionProps {
  numShots?: number;
}

const DEFAULT_NUM_SHOTS = 2;
export function OnboardingConfettiExplosion({numShots = DEFAULT_NUM_SHOTS}: OnboardingConfettiExplosionProps): ReactElement | null {
  const refAnimationInstance = useRef<CreateTypes | null>(null);
  const startingTime = 200;
  const shotInterval = 800;

  const setShots = (): void => {
    for (let i = 0; i < numShots; i++) {
      setTimeout(
        (): void => {
          fire();
        },
        startingTime + i * shotInterval
      );
    }
  };

  useEffect(() => {
    setShots();
  }, []);

  const makeShot = useCallback((particleRatio: number, opts: Options) => {
    void (
      refAnimationInstance.current &&
      refAnimationInstance.current({
        ...opts,
        origin: {y: 0.7},
        particleCount: Math.floor(200 * particleRatio),
      })
    );
  }, []);

  const fire = useCallback(() => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55,
    });

    makeShot(0.2, {
      spread: 60,
    });

    makeShot(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45,
    });
  }, [makeShot]);

  const getInstance = useCallback((confetti: CreateTypes | null) => {
    refAnimationInstance.current = confetti;
  }, []);

  return (
    <ReactCanvasConfetti
      refConfetti={getInstance as any}
      style={{
        position: 'fixed',
        pointerEvents: 'none',
        width: '100%',
        height: '100%',
        top: '-90px',
        // TODO: ask with the editor team if this is ok
        zIndex: '10000',
        left: 0,
      }}
    />
  );
}
